module.exports = __webpack_public_path__ + "img/card3.7506da6b.svg";